<template>
  <DashboardTemplate :navMenu="true">
    <div v-loading="loading">
      <div class="text-left pd-b-3">
        <h2 v-if="subject" class="mg-less">แก้ไข{{ subject.name }}</h2>
      </div>
      <SubjectForm
        @updateSubject="updateSubject"
        :subject="subject"
        type="update"
      />

      <div class="text-left pd-b-3">
        <h2 class="mg-less pd-b-4">ตั้งค่ากิจกรรม</h2>
        <el-row :gutter="30" class="text-change-nowrap">
          <el-checkbox-group v-model="activity" @change="updateActivity">
            <el-col
              v-for="item in activityList"
              :key="item.id"
              :span="24"
              :md="12"
              class="pd-y-5"
            >
              <el-tooltip
                class="item"
                effect="dark"
                content="กรุณาเพิ่มแบบทดสอบก่อนเรียน"
                :disabled="item.id != 1"
                placement="bottom"
              >
                <el-checkbox :label="item.id" :disabled="item.id == 1">{{
                  item.name
                }}</el-checkbox>
              </el-tooltip>
            </el-col>
          </el-checkbox-group>
        </el-row>
      </div>
      <el-tabs v-model="activeName" class="secondary">
        <el-tab-pane v-if="showTab(1)" label="Pre-Test" name="1">
          <CourseTestList
            v-if="subject"
            @fetchSubjectId="fetchSubjectId"
            :coureTestList="subject.preTest"
            :coureTestListCopy="subject.postTest"
            :durationTime="subject.durationTimePreTest"
          />
        </el-tab-pane>
        <el-tab-pane v-if="showTab(0)" label="หัวข้อ (วีดีโอ)" name="0">
          <TopicList
            v-if="subject"
            @fetchSubjectId="fetchSubjectId"
            :topicList="subject.topics"
        /></el-tab-pane>
        <el-tab-pane v-if="showTab(2)" label="Discussion Forum" name="2">
          <DiscussionForumList
            v-if="subject"
            @fetchSubjectId="fetchSubjectId"
            :discussionForumConst="subject.discussion"
          />
        </el-tab-pane>
        <el-tab-pane v-if="showTab(3)" label="Assignment" name="3">
          <AssignmentList
            v-if="subject"
            @fetchSubjectId="fetchSubjectId"
            :assignmentList="subject.assignment"
        /></el-tab-pane>
        <el-tab-pane v-if="showTab(4)" label="Post-Test" name="4"
          ><CourseTestList
            testType="postTest"
            v-if="subject"
            @fetchSubjectId="fetchSubjectId"
            :coureTestList="subject.postTest"
            :coureTestListCopy="subject.preTest"
            :durationTime="subject.durationTimePostTest"
        /></el-tab-pane>
      </el-tabs>
      <el-dialog
        title="กำลังอัปโหลดข้อมูล..."
        :visible.sync="dialogProgress"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        top="25vh"
        :width="widthMax < 767.98 ? '80%' : null"
        class="text-center padding-top-10"
      >
        <el-progress
          type="circle"
          :percentage="progress"
          :width="widthMax < 767.98 ? 200 : 250"
          :color="[
            { color: '#ff8f8c', percentage: 30 },
            { color: '#ffb800', percentage: 60 },
            { color: '#04cc24', percentage: 80 },
          ]"
        ></el-progress>
      </el-dialog>
    </div>
  </DashboardTemplate>
</template>

<script>
import DashboardTemplate from "@/template/DashboardTemplate";
import SubjectForm from "@/components/subject/SubjectForm";
import TopicList from "@/components/topic/TopicList";
import AssignmentList from "@/components/assignment/AssignmentList";
import CourseTestList from "@/components/courseTest/CourseTestList";
import DiscussionForumList from "@/components/discussionForum/DiscussionForumList";
import { HTTP } from "@/service/axios.js";

export default {
  components: {
    DashboardTemplate,
    SubjectForm,
    TopicList,
    AssignmentList,
    CourseTestList,
    DiscussionForumList,
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
  },
  data() {
    return {
      activity: [],
      activityList: [
        { id: 1, name: "แบบทดสอบก่อนเรียน (Pre-Test)" },
        { id: 0, name: "หัวข้อ (วีดีโอ)" },
        { id: 2, name: "กระดานถาม - ตอบระหว่างเรียน (Discussion Forum)" },
        { id: 3, name: "งานที่ได้รับมอบหมาย (Assignment)" },
        { id: 4, name: "แบบทดสอบหลังเรียน (Post-Test)" },
      ],
      activeName: "1",

      // activeName: "topic",
      subject: null,
      loading: true,
      dialogProgress: false,
      progress: 0,
      widthMax: window.innerWidth,
    };
  },
  mounted() {
    this.fetchCourseList();
    this.fetchSubjectId();
    window.addEventListener("resize", this.resize);
  },
  methods: {
    resize() {
      this.widthMax = window.innerWidth;
    },
    fetchCourseList() {
      let obj = {
        token: this.token,
      };
      this.$store.dispatch("FETCH_COURSE_LIST", obj);
    },
    showTab(id) {
      let filter = this.activity.filter((filter) => filter == id);
      return filter.length > 0 ? true : false;
    },
    setActivity() {
      this.activity = [];

      if (
        this.subject != null &&
        (typeof this.subject.activity.topic == "undefined" ||
          this.subject.activity.topic)
      ) {
        this.activity.push(0);
      }

      this.activity.push(1);

      if (this.subject != null && this.subject.activity.discussion) {
        this.activity.push(2);
      }

      if (this.subject != null && this.subject.activity.assignment) {
        this.activity.push(3);
      }

      if (this.subject != null && this.subject.activity.postTest) {
        this.activity.push(4);
      }
    },
    fetchSubjectId() {
      let obj = {
        subjectId: this.$route.query.subjectId,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`get/subject`, obj)
        .then((res) => {
          if (res.data.success) {
            this.subject = res.data.obj;

            this.setActivity();
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("fetchSubjectId error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
    updateSubject(data, del, loading) {
      if (loading) {
        this.loading = true;
      } else {
        this.progress = 0;
        this.dialogProgress = true;
      }

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      let formData = new FormData();
      formData.append("courseId", this.$route.query.courseId);
      formData.append("subjectId", this.$route.query.subjectId);

      formData.append("name", data.subjectName);
      formData.append("instructor", data.instructor);

      formData.append("description", data.courseDescription);
      formData.append(
        "durationTime",
        JSON.stringify({
          open: data.subjectDistanceDate[0],
          close: data.subjectDistanceDate[1],
        })
      );
      formData.append(
        "totalStudyTime",
        JSON.stringify({
          hours: data.timeLearn.hour != null ? data.timeLearn.hour : 0,
          minute: data.timeLearn.min != null ? data.timeLearn.min : 0,
        })
      );

      data.courseAudioFile.map((item, index) => {
        if (item.raw != null && typeof item.raw != "undefined") {
          formData.append("attach", item.raw);
        }
      });

      if (del != null) {
        del.courseAudioFileDel.map((item, index) => {
          formData.append("delFiles", item);
        });
      }

      data.courseDocumentFile.map((item, index) => {
        if (item.raw != null && typeof item.raw != "undefined") {
          formData.append("document", item.raw);
        }
      });

      if (del != null) {
        del.courseDocumentFileDel.map((item, index) => {
          formData.append("delDocument", item);
        });
      }

      let activity = {
        topic: this.showTab(0),
        preTest: true,
        discussion: this.showTab(2),
        assignment: this.showTab(3),
        postTest: this.showTab(4),
      };

      formData.append("activity", JSON.stringify(activity));
      formData.append("index", data.number);

      let interval = setInterval(() => {
        if (this.progress < 80) {
          this.progress += 2;
        }
        setTimeout(() => {
          if (this.progress < 95) {
            this.progress += 1;
          }
        }, 1000);
      }, 1500);

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.put(`subject`, formData, config)
        .then((res) => {
          if (res.data.success) {
            this.fetchCourseList();
            this.fetchSubjectId();
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("updateSubject error", e);
        })
        .finally(() => {
          clearInterval(interval);
          this.progress = 95;
          setTimeout(() => {
            this.loading = false;
            this.progress = 100;
            setTimeout(() => {
              this.dialogProgress = false;
            }, 500);
          }, 500);
        });
    },
    updateActivity() {
      let filter = this.activity.filter(
        (filter) => filter == Number(this.activeName)
      );

      if (filter.length == 0) {
        this.activeName = "1";
      }

      let obj = {
        subjectName: this.subject.name,
        instructor: this.subject.instructor,
        subjectDistanceDate: [
          this.subject.durationTime.open,
          this.subject.durationTime.close,
        ],
        courseDescription: this.subject.description,
        timeLearn: {
          hour: this.subject.totalStudyTime.hours,
          min: this.subject.totalStudyTime.minute,
        },
        courseAudioFile: [],
        courseDocumentFile: [],
        number: this.subject.index,
      };

      this.updateSubject(obj, null, true);
    },
  },
};
</script>
